import Api from '@/services/Api'

export default {
  get(groupOfDiscountsId) {
    return Api().get(`groups-of-discounts/${groupOfDiscountsId}/discounts`).then(function (response) {
      return (response)
    })
  },
  getByCampaignId(campaignId) {
    return Api().get(`campaigns/${campaignId}/discounts`).then(function (response) {
      return (response)
    })
  },  
  add(groupOfDiscountsId, data) {
      return Api().post(`groups-of-discounts/${groupOfDiscountsId}/discounts`, data).then(function (response) {
        return (response)
      })
  },
  getById(id) {
      return Api().get(`discounts/${id}`).then(function (response) {
        return (response)
      })
  },
  partialUpdate(id, data) {
      return Api().patch(`discounts/${id}`, data).then(function (response) {
        return (response)
      })
  }
}